'use client';

import type React from 'react';
import styles from './FocusSkip.module.scss';

interface FocusSkipProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  label: string;
}

export const FocusSkip: React.FC<FocusSkipProps> = ({ href, label, ...props }) => {
  const handleActivation = (
    event: React.MouseEvent<HTMLAnchorElement> | React.KeyboardEvent<HTMLAnchorElement>,
  ) => {
    event.preventDefault();

    // Extract the target ID from the href (remove the # prefix)
    const targetId = href.replace('#', '');
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      // Focus the target element without updating the URL
      targetElement.focus();

      // Ensure the element is scrolled into view if needed
      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLAnchorElement>) => {
    // Handle Enter and Space keys for accessibility
    if (event.key === 'Enter' || event.key === ' ') {
      handleActivation(event);
    }
  };

  return (
    <a
      href={href}
      title={label}
      className={styles.focusSkip}
      onClick={handleActivation}
      onKeyDown={handleKeyDown}
      {...props}
    >
      {label}
    </a>
  );
};
